module.exports = __webpack_public_path__ + "img/extra-box.783e2b91.svg";